// extracted by css-extract-rspack-plugin
export default {"SettingsSection":"ZNk1D","PageWrapper":"Mn9x6","SectionWrapper":"Y6Rqe"};